<template>
    <div class="mt-4">
        <b-row class="pr-3">
            <b-col class="pr-0 pb-1 align-self-end">
                <b-form-group label="Process">
                    <multiselect v-model="selected_process" :options="processList" :multiple="false" track-by="name" label="name" />
                </b-form-group>
            </b-col>
            <template v-if="selected_process">
                <b-col>
                    <b-form-group label="Intrument Type">
                        <multiselect v-model="selected_instrument_type" :options="instrumentTypeList" :multiple="false" track-by="name" label="name" />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="Intrument">
                        <multiselect v-model="selected_instrument" :options="instrument_list" :multiple="false" track-by="name" label="name" />
                    </b-form-group>
                </b-col>
            </template>
        </b-row>
        <b-row v-if="selected_process">
            <b-col v-if="tasks && Object.keys(tasks).length">
                <h6>Tasks</h6>
                <b-form-group v-for="(taskGroup, exportWorkbook) in tasks" :key="exportWorkbook" :label="_.startCase(_.toLower(exportWorkbook))">
                    <b-button class="mr-1" v-for="(task, index) in taskGroup" :variant="checkTask(task)" :key="index" :disabled="selected_export_workbook ? selected_export_workbook !== exportWorkbook : false" @click="pickTask(task)">{{ task.name }}</b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import InstrumentInstanceCollection from "@/collections/lab/InstrumentInstanceCollection";

export default {
    name: "IntrumentRunnerFormFields",
    components: {
        Multiselect,
    },
    props: {
        processes: {
            type: Array,
            required: true,
        }
    },
    computed: {
        processList() {
            return this.processes.map((process) => {
                return {
                    value: process.schedulable_process.id,
                    process: process,
                    schedulableProcess: process.schedulable_process,
                    name: process.schedulable_process.name,
                }
            });
        },
        instrumentTypeList() {
            const all = this.selected_process ? this.selected_process.process.process_schedule_instrument_instances.map((instruments) => {
                return {
                    value: instruments.instrument_id,
                    instrumentInstanceId: instruments.instrument_instance_id,
                    instrumentInstance: instruments.instrument_instance,
                    name: (instruments.instrument ? instruments.instrument.name : null)
                };
            }) : [];

            return !all.length ? all : [...new Map(all.map(item => [item.value, item])).values()];
        },
        tasks() {
            // check if no selected process is available
            if (!this.selected_process) {
                return [];
            }

            // return a reduced array containing only tasks without a parent
            // tasks with a parent_id are part of a group and are tested together.
            const schedulable_tasks = this.selected_process.schedulableProcess.schedulable_tasks
                .reduce(
                    (result, task) => {
                        result.push({
                            value: task,
                            name: task.name,
                            export_workbook: task.export_workbook || '',
                        });
                        return result;
                    }, []
                );

            return _.groupBy(schedulable_tasks, 'export_workbook');
        },
    },
    data() {
        return {
            selected_tasks: [],
            selected_process: null,
            selected_instrument_type: null,
            selected_instrument: null,
            instrument_list: [],
            instrument_instance_models: [],
            selected_export_workbook: null,
        };
    },
    methods: {
        checkTask(incomingTask) {
            const id = incomingTask.value.id;
            return this.selected_tasks.find((task) => task === id)
                ? "primary"
                : "light";
        },
        pickTask(incomingTask) {
            const id = incomingTask.value.id;

            const check = this.selected_tasks.find((task) => task === id);

            this.selected_tasks = check
                ? this.selected_tasks.filter((task) => task !== id)
                : [...this.selected_tasks, id];

            this.selected_export_workbook = this.selected_tasks.length
                ? incomingTask.export_workbook
                : null;

            //this.updateFilters();
        },
        emitFormFields() {
            this.$emit("formFieldsUpdated", {
                schedulable_process_id: this.selected_process ? this.selected_process.value : null,
                instrument_id: this.selected_instrument_type ? this.selected_instrument_type.value : null,
                instrument_instance_id: this.selected_instrument ? this.selected_instrument.value : null,
                tasks: this.selected_tasks,
            });
        },
        getInstruments() {
            const collection = new InstrumentInstanceCollection();

            collection.getFilter().filterEquals("instrument_id", this.selected_instrument_type.value);

            collection.fetch().then(() => {
                this.instrument_instance_models = collection.models;
            });
        },
    },
    watch: {
        selected_process: {
            handler() {
                this.selected_instrument_type = null;
                this.selected_instrument = null;
                this.selected_tasks = [];
                this.emitFormFields();
            },
            deep: true,
            immediate: true
        },
        selected_instrument_type: {
            handler() {
                if (this.selected_instrument_type && this.selected_instrument_type.instrumentInstanceId) {
                    // set the instrument to be of the instrument instance
                    this.instrument_list = [{
                        value: this.selected_instrument_type.instrumentInstanceId,
                        name: this.selected_instrument_type.instrumentInstance.name
                    }];
                    this.emitFormFields();
                    return;
                }

                this.getInstruments();
            },
            deep: true,
            immediate: false,
        },
        instrument_instance_models: {
            handler() {
                // if the list becomes empty just ignore this state
                if (!this.instrument_instance_models.length) {
                    return;
                }

                this.instrument_list = this.instrument_instance_models.map((instrumentInstance) => {
                    return {
                        value: instrumentInstance.id,
                        name: instrumentInstance.name
                    }
                });
            },
            deep: true,
            immediate: true
        },
        selected_instrument: {
            handler() {
                this.emitFormFields();
            },
            deep: true,
            immediate: true
        },
        selected_tasks: {
            handler() {
                this.emitFormFields();
            },
            deep: true,
            immediate: true,
        }
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />
